<template>
    <div :class="`${surveyMode ? 'time-picker-sublabel-mode' : ''}`">
      <p v-if="surveyMode" class="surveys-common-label pb-0 mb-1" >
          {{`${requiredCharLabel}`}}
          <span v-if="sublabel" class="surveys-common-sublabel"><br> {{sublabel}}</span>
      </p>
      <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="time"
        transition="scroll-y-transition"
        offset-y
        max-width="290px"
        min-width="290px"
        :disabled="readonly"
        >
        <template v-slot:activator="{ on, attrs }">
            <textFieldForm
            
            :bindInput="attrs"
            :onInput="on"
            :label="surveyMode ? '' : label"
            :valueInput="time"
            :rule="rule"
            prependInnerIcon="mdi-clock-time-four-outline"
            :errorMessages="errorMessages"
            :clearable="true"
            :readonly="true"
            @valueChange="(v) => {time = v == null ? '' : v}"
          ></textFieldForm>
          
           
        </template>
        <v-time-picker
            format="24hr"
            v-if="menu"
            v-model="time"
            full-width
            color="primary"
            @click:minute="$refs.menu.save(time)"
            @change="setTime"
        ></v-time-picker>
    </v-menu>
    </div>
</template>

<script>
  export default {
      props: ['valueInput', 'rule','label', 'hint', 'errorMessages', 'sublabel', 'surveyMode', 'readonly'],
      computed:{
        time: {
          get: function() {
              
              return this.valueInput
          },
          set: function(value) {
              this.$emit('valueChange', value)
          }
        },
        requiredCharLabel:{
            get: function(){
                if(this.label == "" || this.label == undefined)
                    return "";
                const response = this.label + " *";
                for (let i = 0; i < (this?.rule?.length??[]); i++) {
                    if(this.rule[i]("") != true){
                        return response;
                    }
                }
                return this.label;
            }
        }
      },
      data(){
        return {
          // time: '',
          menu: false,
          requiredRule: [
            v => !!v || 'Campo requerido'
          ]
        }
      },
      mounted() {
        if(typeof this.valueInput !== 'undefined')
          this.time = this.valueInput
      },
      methods: {
        setTime(timeIn){
            this.$emit('valueChange', timeIn)
        }
      }
  }
</script>

<style lang="scss" >

   .time-picker-sublabel-mode .v-text-field .v-input__control .v-input__slot input{
        // //margin-bottom: 8px;
        margin-top: 0px !important;
        padding: 0;
    }
    .time-picker-sublabel-mode .v-text-field .v-input__control .v-input__slot input{
    //margin-bottom: 8px;
        margin-top: 1px !important;
        padding: 0;
    }

</style>